import axios from 'axios'
import CONFIG from '../../config'

export async function geoCode (location) {
  const { lat, lng } = location
  if (!lat || !lng) return

  try {
    const apiUrl = `${CONFIG.api_url}/originaddress/?latitude=${lat}&longitude=${lng}`
    const { data } = await axios.get(apiUrl)
    return data?.formatted_address || ''
  } catch (err) {

  }
}
